import $http from '@vue-util/http';

import { errorHandler } from '@/utils/ErrorHandler';
import { BACKORDER_CONFIRMATION_ENDPOINT, BACKORDER_CONFIRMATION_ENDPOINT_V2 } from '#shared/endpoints';
import { ORDER_DETAILS } from 'config';

import { useOrderDetailsStore } from '@/stores/useOrderDetailsStore';
import { useTrackPackageStore } from '@/stores/useTrackPackageStore';

const { backOrderConfirmationFallbackError } = ORDER_DETAILS;

export const useBackOrderConfirmationStore = defineStore('backOrderConfirmationStore', {
  state: () => ({
    updateWaitApiError: null,
    updateCancelApiError: null,
  }),
  actions: {
    SET_UPDATE_BACKORDER_WAIT_API_ERROR(payload) {
      this.updateWaitApiError = payload;
    },
    SET_UPDATE_BACKORDER_CANCEL_API_ERROR(payload) {
      this.updateCancelApiError = payload;
    },

    async GET_BACKORDER_CONFIRMATION({ payload, reqBody }) {
      this.SET_UPDATE_BACKORDER_WAIT_API_ERROR(null);
      const requestBody = payload.fedfilToUopMigrationWaitForItemEnabled ? { order: reqBody } : reqBody;

      try {
        let url = `${BACKORDER_CONFIRMATION_ENDPOINT}/${payload.reservationNumber}/item/wait`;
        if (payload.fedfilToUopMigrationWaitForItemEnabled) {
          url = `${BACKORDER_CONFIRMATION_ENDPOINT_V2}/${payload.reservationNumber}/item/wait`;
        }
        await $http.post(url, requestBody, {
          headers: {
            ...(payload.userId && payload.isSignedIn && { 'X-Macys-UID': encodeURIComponent(payload.userId) }),
          },
        });
        if (payload.isTrackPackageCall) {
          useTrackPackageStore().GET_TRACKING_PACKAGE_DETAILS({
            orderToken: payload.orderToken,
            shipmentToken: payload.shipmentToken,
            trackingNos: payload.trackingNos,
          });
        } else {
          useOrderDetailsStore().GET_ONLINE_ORDER_DETAILS({ payload });
        }
      } catch (error) {
        payload.isTrackPackageCall
          ? useTrackPackageStore().SET_TRACK_PACKAGE_DETAILS_ERROR({ msg: errorHandler(error, backOrderConfirmationFallbackError), keepState: true })
          : useOrderDetailsStore().SET_ONLINE_ORDER_DETAILS_ERRORS({ msg: errorHandler(error, backOrderConfirmationFallbackError), keepState: true });
        this.SET_UPDATE_BACKORDER_WAIT_API_ERROR(error?.response?.data?.errors?.error?.[0]);
      }
    },

    async CANCEL_ITEM({ payload, reqBody }) {
      this.SET_UPDATE_BACKORDER_CANCEL_API_ERROR(null);
      const requestBody = payload.fedfilToUopMigrationCancelItemEnabled ? { order: reqBody } : reqBody;
      try {
        let url = `${BACKORDER_CONFIRMATION_ENDPOINT}/${payload.reservationNumber}/item/cancel`;
        if (payload.fedfilToUopMigrationCancelItemEnabled) {
          url = `${BACKORDER_CONFIRMATION_ENDPOINT_V2}/${payload.reservationNumber}/item/cancel`;
        }
        await $http.put(url, requestBody, {
          headers: {
            ...(payload.userId && payload.isSignedIn && { 'X-Macys-UID': encodeURIComponent(payload.userId) }),
          },
        });
        if (payload.isTrackPackageCall) {
          useTrackPackageStore().GET_TRACKING_PACKAGE_DETAILS({
            orderToken: payload.orderToken,
            shipmentToken: payload.shipmentToken,
            trackingNos: payload.trackingNos,
          });
        } else {
          useOrderDetailsStore().GET_ONLINE_ORDER_DETAILS({ payload });
        }
      } catch (error) {
        payload.isTrackPackageCall
          ? useTrackPackageStore().SET_TRACK_PACKAGE_DETAILS_ERROR({ msg: errorHandler(error, backOrderConfirmationFallbackError), keepState: true })
          : useOrderDetailsStore().SET_ONLINE_ORDER_DETAILS_ERRORS({ msg: errorHandler(error, backOrderConfirmationFallbackError), keepState: true });
        this.SET_UPDATE_BACKORDER_CANCEL_API_ERROR(error?.response?.data?.errors?.error?.[0]);
      }
    },
  },
});
